// Navbar.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function NoteSearch(){ 

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const showRemainingNoteSearch = useSelector((state) => state.noteSearch.showRemainingNoteSearch);
    const noteSearchStringClearButton = useSelector((state) => state.noteSearch.noteSearchStringClearButton);
    const noteSearchString = useSelector((state) => state.noteSearch.noteSearchString);
    const noteSearchStringPlaceHolder = useSelector((state) => state.noteSearch.noteSearchStringPlaceHolder);
    const loading4Home = useSelector((state) => state.home.loading4Home);
    const pageNumberNoteSearch = useSelector((state) => state.noteBookmarkList.pageNumberNoteSearch);
    const confirmedNoteSearchString = useSelector((state) => state.noteSearch.confirmedNoteSearchString);

    //const [showRemainingNoteSearch, sethowRemainingNoteSearch] = useState(false);

    const handleOnClickNoteSearchString = () => {
        dispatch(setConfirmedNoteSearchString(noteSearchString));
        dispatch(setPageNumberNoteSearch(0));
        dispatch(setShowfabContentNoteSearch(true));
        dispatch(setViewArea('NoteSearch'));
        dispatch(setShowRemainingNoteSearch(true));

        // dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
        // if (noteSearchString === null) {
        //     getNoteBookmarkList3('', 'NoteBookmarkList');   
        //     dispatch(setNoteSearchString(''));     
        // } else {
        //     getNoteBookmarkList3(noteSearchString, 'NoteBookmarkList');        
        // }       
    }

    const handleOnClickClearNoteSearchString = () => {
        dispatch(setNoteSearchString(''));
        dispatch(setNoteSearchStringClearButton(false));
        //dispatch(setShowRemainingNoteSearch(false));
    }

    const handleOnChangeNoteSearchString = (e) => {
        let value = e.target.value;
        value = value.replace(/\s+/g, '');
        value.length > 0 ? dispatch(setNoteSearchStringClearButton(true)): dispatch(setNoteSearchStringClearButton(false));
        if (value.length <= MAX_LENGTH_SEARCH_STRING) {
        dispatch(setNoteSearchString(value));
        //dispatch(setShowRemainingNoteSearch(false));
        } else {

        }
    }

    // useEffect(() => {        
    //     dispatch(setNoteBookmarkList({resultTotal: -1, noteBookmarkList: []}));
    //     if (noteSearchString !== null) {
    //         getNoteBookmarkList3(noteSearchString, 'NoteBookmarkList');
    //     }
    // }, [pageNumberNoteSearch]);

    useEffect(() => {
        //dispatch(reset4NoteSearch());
        //dispatch(reset4NoteBookmarkList());
        //dispatch(setShowRemainingNoteSearch(false));
        //dispatch(setNoteSearchString(null));
        dispatch(setNoteSearchStringPlaceHolder(`輸入最多${MAX_LENGTH_SEARCH_STRING}字`));
        dispatch(setViewArea('NoteSearch'));
    }, []);

    useEffect(() => {
        return () => {
            //dispatch(setPageNumberNoteSearch(-1)); // Reset state on unmount
            //dispatch(reset4NoteSearch());
        };
    }, []);

    return (

        <div>

            <Navbar />

            <div style={{ paddingTop: '50px' }}>

                <Container sx={{ mt: 4, mb: 4 }}>

                    <Card sx={{ boxShadow: 'none', backgroundColor: '#eeeeee', padding: 2 }}>

                        <Grid container spacing={2}>

                            <Grid size={12}>

                                <Typography gutterBottom variant="h5" component="div" sx={{ color: '#bdbdbd' }}>
                                標題內容字串
                                </Typography>

                                <Paper
                                component="form"
                                sx={{ boxShadow: 'none', display: 'flex', alignItems: 'center', width: '100%' }}
                                >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder={noteSearchStringPlaceHolder}
                                    value={noteSearchString}
                                    onChange={handleOnChangeNoteSearchString}
                                />

                                {noteSearchStringClearButton &&
                                <IconButton type="button" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickClearNoteSearchString}>
                                    <ClearIcon  />
                                </IconButton>
                                }

                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                
                                <IconButton color="primary" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickNoteSearchString}>
                                    <CheckIcon  />
                                </IconButton>

                                </Paper>

                            </Grid>                            
                                
                        </Grid>

                    </Card>

                    <Grid container spacing={2}>

                        {showRemainingNoteSearch &&
                        <Grid xs={12}>
                            <div>
                                <NoteBookmarkList caller={'NoteSearch'}/>
                            </div>  
                        </Grid>
                        }                                        

                    </Grid>

                </Container>

            </div>

            {/* {loading4Home && <ClipLoader1 />} */}

            <ConfirmationDialog />

        </div>

    );
};